import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class BrowserLocalStorageService extends BrowserStorageService {
  private readonly MFA_PROMPT_KEY = 'mfaPromptDismissedTimestamp';

  constructor() {
    const platformId = inject(PLATFORM_ID);

    super(platformId, window.localStorage);
  }

  public getMfaNudgeSeenTimestamp() {
    return Number(this.get(this.MFA_PROMPT_KEY) || 0);
  }

  public setMfaNudgeSeenTimestamp(): void {
    this.set(this.MFA_PROMPT_KEY, Date.now());
  }
}
